import React, {Component} from 'react';
import './FormErrorMessages.css';

class FormErrorMessages extends Component {

  render() {
    const {errors} = this.props;

    if (errors) {
      return (
      <div className="submission-errors">
        <ul>
          {Object.keys(errors).map((key,index)=><li key={'error_'+index}>{errors[key]}</li>)}
        </ul>
      </div>
      );
    }

    return null;
  }
}

export default FormErrorMessages;


// WEBPACK FOOTER //
// ./src/package-form/FormErrorMessages.js